import { TitleCasePipe } from '@angular/common';

const titleCasePipe = new TitleCasePipe();

/** 'group manager' -> 'Group Manager' */
export function titleCase(value?: Nullable<string>): string {
  return titleCasePipe.transform(value ?? '');
}
